export const getPublicationStatus = (item) => {
  if (item?.publishedAt || item?.status === 'Publicado') return 'Publicado';
  if (item?.status === 'Error') return 'Error';
  if (item?.scheduledAt || item?.status === 'Programado') return 'Programado';
  return 'Pendiente';
};
